const COOKIES_KEYS = {
  TOKEN: 'token',
  GDPR_CONSENT: 'gdprConsent',
  PLAYGROUND_USER_ID: 'gsPlaygroundUserId'
};

export default COOKIES_KEYS;
